

import { IChangeTracking } from "../../../changeTracking/iChangeTracking";


export class RequestMaterials implements IChangeTracking {

    private _current: any;

    constructor(private _model: any) {
        this._current = this._model ? angular.copy(this._model) : {};
    }

    get materialId(): number {
        return this._current.materialId;
    }

    set materialId(value: number) {
        this._current.materialId = value;
    }


    get materialTypeId(): string {
        return this._current.materialTypeId;
    }

    set materialTypeId(value: string) {
        this._current.materialTypeId = value;
    }
    get materialDesc(): string {
        return this._current.materialDesc;
    }

    set materialDesc(value: string) {
        this._current.materialDesc = value;
    }

    get description(): string {
        return this._current.description;
    }

    set description(value: string) {
        this._current.description = value;
    }

    get description2(): string {
        return this._current.description2;
    }

    set description2(value: string) {
        this._current.description2 = value;
    }

    get modelNo(): string {
        return this._current.modelNo;
    }

    set modelNo(value: string) {
        this._current.modelNo = value;
    }

    get yearAcquired(): number {
        return this._current.yearAcquired;
    }

    set yearAcquired(value: number) {
        this._current.yearAcquired = value;
    }

    get assetNumber(): string {
        return this._current.assetNumber;
    }

    set assetNumber(value: string) {
        this._current.assetNumber = value;
    }

    get htsCode(): string {
        return this._current.htsCode;
    }

    set htsCode(value: string) {
        this._current.htsCode = value;
    }

    get quantity(): number {
        return this._current.quantity;
    }

    set quantity(value: number) {
        this._current.quantity = value;
    }


    get netWeight(): number {
        return this._current.netWeight;
    }

    set netWeight(value: number) {
        this._current.netWeight = value;
    }

    get costPerUnit(): number {
        return this._current.costPerUnit;
    }

    set costPerUnit(value: number) {
        this._current.costPerUnit = value;
    }

    get total(): number {
        return this._current.total;
    }

    set total(value: number) {
        this._current.total = value;
    }

    get country(): string {
        return this._current.country;
    }

    set country(value: string) {
        this._current.country = value;
    }


    // Additional Details

    get manufacturerName(): string {
        return this._current.manufacturerName;
    }

    set manufacturerName(value: string) {
        this._current.manufacturerName = value;
    }

    get contactName(): string {
        return this._current.contactName;
    }

    set contactName(value: string) {
        this._current.contactName = value;
    }

    get phoneNumber(): string {
        return this._current.phoneNumber;
    }

    set phoneNumber(value: string) {
        this._current.phoneNumber = value;
    }

    get addressLine1(): string {
        return this._current.addressLine1;
    }

    set addressLine1(value: string) {
        this._current.addressLine1 = value;
    }

    get addressLine2(): string {
        return this._current.addressLine2;
    }

    set addressLine2(value: string) {
        this._current.addressLine2 = value;
    }

    get city(): string {
        return this._current.city;
    }

    set city(value: string) {
        this._current.city = value;
    }

    get postalCode(): string {
        return this._current.postalCode;
    }

    set postalCode(value: string) {
        this._current.postalCode = value;
    }


    get regionCode(): string {
        return this._current.regionCode;
    }

    set regionCode(value: string) {
        this._current.regionCode = value;
    }

    get isDeleted(): boolean {
        return this._current.isDeleted;
    }

    set isDeleted(value: boolean) {
        this._current.isDeleted = value;
    }

    get manufactureCountryCode(): string {
        return this._current.manufactureCountryCode;
    }

    set manufactureCountryCode(value: string) {
        this._current.manufactureCountryCode = value;
    }

    get recordNumber(): number {
        return this._current.recordNumber;
    }

    set recordNumber(val: number) {
        this._current.recordNumber = val;
    }


    hasChanges(): boolean {
        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);
    }

    commit(): void {
        this._model = angular.copy(this._current);
    }

    toJson(): any {
        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/models/requestMaterials.ts
 **/